import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProvedorDeSessao, useSessao } from './autenticacao/ContextoDeSessao.js';
import { FronteiraDeErro } from './componentes/FronteiraDeErro.js';
import { Moldura } from './componentes/Moldura.js';
import { Login } from './paginas/Login.js';
import { Operadores } from './paginas/Operadores.js';
import { Painel } from './paginas/Painel.js';
import { Ficha } from './paginas/ficha/Ficha.js';

const consultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Dados de funil mudam por ação do operador, não sozinhos — refetch agressivo só
      // gasta requisição. O que muda por fora (webhook do Asaas) chega ao voltar à aba.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (tentativas, erro) => {
        const status = (erro as { status?: number }).status;
        if (status && status < 500) return false; // 4xx não melhora com repetição
        return tentativas < 2;
      },
    },
  },
});

export function App() {
  return (
    <FronteiraDeErro>
      <QueryClientProvider client={consultas}>
        <ProvedorDeSessao>
          <BrowserRouter>
            <Rotas />
          </BrowserRouter>
        </ProvedorDeSessao>
      </QueryClientProvider>
    </FronteiraDeErro>
  );
}

function Rotas() {
  const { operador, carregando } = useSessao();

  if (carregando) {
    return <div className="carregando">Verificando a sessão…</div>;
  }

  if (!operador) {
    return <Login />;
  }

  return (
    <Moldura>
      <Routes>
        <Route path="/" element={<Painel />} />
        {/*
          `novo` é ficha em branco — só vira registro quando o closer salvar. Ele viaja
          como valor de `:id`, e não como rota própria: uma rota estática venceria a
          dinâmica e entregaria `useParams()` vazio, travando a ficha em "carregando".
        */}
        <Route path="/candidatos/:id" element={<Ficha />} />
        {/* A própria página recusa quem não é admin — a API também, que é o que vale. */}
        <Route path="/operadores" element={<Operadores />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Moldura>
  );
}
